<script>
export default {
    name: "RightsAssignment",

    data() {

        return {
            groupedrights: {},
            parentroles: [],
            rights: [],
            roles: [],
            roleID: null,
            roleRights: []
        };
    },

    watch: {

        roleID() {

            if(!this.roleID) return;

            this.fetchRoleRights();
        },
    },

    mounted() {

        this.fetchRights();
        this.fetchRoles();
    },

    methods: {

        fetchRights() {
            this.$root.loading = true;
            this.$http.get(`Admin/GetGroupedSystRights`).then(response => {
                this.groupedrights = response.data;
                this.parentroles=this.groupedrights.parentRoles;
this.rights=this.groupedrights.sysRightList;
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },

        fetchRoles() {
            this.$root.loading = true;
            this.$http.get(`Admin/GetActiveRoles`).then(response => {
                this.roles = response.data;
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },

        fetchRoleRights() {
            this.$root.loading = true;
            this.$http.get(`Admin/GetSpecificRoleRight?RoleID=${this.roleID}`).then(response => {
                    this.roleRights = response.data;
                    this.$root.loading = false;
                }).catch(() => { this.$root.loading = false; });
        },

        checkRoleRight (id) {

            if (!this.roleID) return {};

            const roleRights = this.roleRights.filter(roleRight => roleRight.rightID == id);

            return roleRights.length ? roleRights[0] : {};
        },

        updateRoleRight (roleRight, right) {
            if (!this.roleID) return;
            if (!roleRight.status) {
                roleRight.status = false;
            }

            this.$http.post(`Admin/RolesRights`, 
                { 
                    status: !roleRight.status, 
                    roleID: this.roleID, 
                    rightID: right 
                }).then(() => {
                    this.fetchRoleRights();
            }).catch(() => {});
        },
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
          <h5 class="font-medium text-sm">Assign Rights</h5>
        </template>
        <template v-slot:card-body>
            <div class="flex flex-wrap w-full">
                <div class="w-1/4 p-tiny">
                    <label for="role" class="label-control">Role:</label>
                    <tail-select>
                        <template v-slot:field>
                            <select id="role" v-model="roleID" class="input-control input-sm text-sm">
                                <option v-for="(role, index) in roles" :key="index" :value="role.id">{{ role.role1 }}</option>
                            </select>
                        </template>
                    </tail-select>
                </div>
                <div class="flex flex-wrap w-full overflow-auto" style="height:75vh;">
                 
                         <div class="w-full flex flex-wrap" v-for="(parentrole, indexrole) in parentroles.filter(r => r)" :key="`rights_${indexrole}`">
                          <h5 class=" w-full p-tiny bg-blue-500 rounded-t text-white text-sm">{{ parentrole }}</h5>
                          <div class="w-1/4 px-3 py-1 border flex-wrap" v-for="(right, index) in rights.filter(r => r.parentRole==parentrole && r.description)" :key="`rights_${index}`">
                        <label :for="`right_${index}`" class="font-semibold text-sm p-1">
                            <span class="mr-1">{{ right.description }}</span>
                                <input type="checkbox" @change="updateRoleRight(checkRoleRight(right.id), right.id)" :id="`right_${index}`" :value="checkRoleRight(right.id)" :checked="checkRoleRight(right.id).status == true">
                            </label>
                    </div>
                    </div>
                      <!-- <div class="w-1/4 px-3 py-1 border" v-for="(right, index) in rights.filter(r => r.description)" :key="`rights_${index}`">
                        <label :for="`right_${index}`" class="font-semibold text-sm p-1">
                            <span class="mr-1">{{ right.description }}</span>
                                <input type="checkbox" @change="updateRoleRight(checkRoleRight(right.id), right.id)" :id="`right_${index}`" :value="checkRoleRight(right.id)" :checked="checkRoleRight(right.id).status == true">
                            </label>
                    </div> -->
                </div>
            </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>
